import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { type User } from "./entity";

export const PARTNER_MANAGER_PHONE_LOCKED =
  "רק סופר-אדמין יכול לשנות טלפון של מנהל אפליקציה";

export const UserEntityConfig: HyperEntityConfig<User> = {
  allowApiRead: Allow.authenticated,
  allowApiCrud: true,
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, true);

    filter(Roles.OrganizationManagers, {
    });

    filter(Roles.User, {
      id: remult.user.id,
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, true);
  },

  allowDeletePerRole(allow) {
    allow(Roles.User, (entity) => entity.id === remult.user!.id);
  },

  allowUpdatePerRole(allow) {
    allow(Roles.User, (entity) => entity.id === remult.user!.id);

    allow(Roles.OrganizationManagers, {
      associations: {
        $some: {
          organizationId: remult.user!.organizationId,
        },
      },
    });
  },

  async saving(entity, event) {
    if (!event.isNew && entity.id) {
      const existing = await event.repository.findId(entity.id);
      if (!existing) return;
      if (existing.partnerOrganizationId) {
        if (!remult.isAllowed(Roles.SuperAdmins)) {
          if (entity.phoneNumber !== existing.phoneNumber) {
            throw new Error(PARTNER_MANAGER_PHONE_LOCKED);
          }
          entity.phoneNumber = existing.phoneNumber;
        }
      } else {
        entity.phoneNumber = existing.phoneNumber;
      }
    }
  },
};
